import { FunctionComponent } from 'react';

import { TableBody, TableRow, TableCell, Typography } from '@mui/material';

interface ITableNoDataRowProps {
    columnCount: number;
    noDataTextOverride?: string;
}
export const TableNoDataRow: FunctionComponent<ITableNoDataRowProps> = (props: ITableNoDataRowProps) => {

    return (
        <TableBody>
            <TableRow>
                <TableCell
                    colSpan={props.columnCount}
                    align='center'
                    style={{
                        borderBottom: 'none',
                        padding: '50px 0px'
                    }}>
                    <Typography>
                        <i>
                            {props.noDataTextOverride ?? 'No data available. Please check if you have any filters applied...'}
                        </i>
                    </Typography>
                </TableCell>
            </TableRow>
        </TableBody>
    )
};